import React, { createContext, PropsWithChildren, useContext } from 'react';

interface ThreeDotsClaimContextProps {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  anchorRef: React.RefObject<HTMLButtonElement>;
  generateIdMenu: (id: string) => string;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeThreeDotsClaim: () => void;
}

const ThreeDotsClaimContext = createContext<ThreeDotsClaimContextProps | undefined>(undefined);

export const useThreeDotsClaimContext = () => {
  const context = useContext(ThreeDotsClaimContext);
  if (!context) {
    throw new Error(
      'useThreeDotsClaimContext must be used within a ThreeDotsClaimProvider'
    );
  }
  return context;
};

interface IThreeDotsClaimProviderProps {
  idScreen: string;
}
export const ThreeDotsClaimProvider: React.FC<PropsWithChildren<IThreeDotsClaimProviderProps>> = ({
  children,
  idScreen,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  function closeThreeDotsClaim() {
    setAnchorEl(null);
  }

  const generateIdMenu = (id: string) => `${idScreen}-menu-${id}`;

  return (
    <ThreeDotsClaimContext.Provider
      value={{
        anchorEl,
        generateIdMenu,
        setAnchorEl,
        closeThreeDotsClaim,
        isOpen,
        anchorRef,
        setIsOpen
      }}
    >
      {children}
    </ThreeDotsClaimContext.Provider>
  );
};
